import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import 'chartjs-adapter-moment';


@Component({
  selector: 'app-chart-js',
  templateUrl: './chart-js.component.html',
  styleUrls: ['./chart-js.component.scss'],
})
export class ChartJsComponent implements OnInit {


  _chartData: any;
  // Detect when chartData changes and update chart
  @Input() set chartData(value: any) {
    if (value && value.length > 0) {
      this._chartData = value;
      // If data changed, update the charts
      this.updateCharts();
    }
  };

  _dmus: Array<any> = ["CASE1", "CASN10"];
  @Input() set dmus(value: any) {
    if (value && value.length > 0) this._dmus = value;
  };

  _startDate: Date | undefined;
  @Input() set startDate(value: any) {
    this._startDate = value;
  };

  _endDate: Date | undefined;
  @Input() set endDate(value: any) {
    this._endDate = value;
  };

  _dateAggregation: 'daily' | 'monthly' | 'yearly' = 'daily';
  @Input() set dateAggregation(value: any) {
    this._dateAggregation = value;
  };

  @Input() filterToggle: boolean = true;
  @Input() fullScreen: boolean = false;
  
  // Set min default chart height in px
  minChartHeight: number = 50;
  // Default height per dataset Y axis this value is approximate for calculate graph height
  defaultYAxisHeight: number = 20;

  // Custom chart id
  @Input() chartId: any = 1;
  @Input() order: String = 'dmu';

  lineChart: any;
  matrixChart: any;
  isToastOpen = false;
  isGraphOk = true;
  alert_message = "No hay suficientes datos para generar el gráfico";
  constructor() { }

  ngOnInit() {
    //Start charts
    this.updateCharts();
  }

  public updateCharts() {
    // If one of this values is not present, the chart canot be created
    this.setOpen(false);
    this.lineChart?.clear();
    this.matrixChart?.clear();
    try{
      this.isGraphOk = true;
      if (!this._chartData || !this._dmus || !this._startDate || !this._endDate) {
        return;
      }
      Chart.register(...registerables, MatrixController, MatrixElement);
  
      this.startLineChart();
      this.startMatrixChart();
    }catch (error){
      this.setOpen(true);
      this.isGraphOk = false;
      this.lineChart?.clear();
      this.matrixChart?.clear();
    }
    
  }

  // MATRIX Chart

  startMatrixChart() {
    // Axis Y Labels config
    let chartYLabels: string[] = [];
    if(this.order==='dmu'){
      for (let dmu of this._dmus) {
        for (let label of this._chartData) {
          chartYLabels.push(dmu + " - " + label.name)
        }
      }
    }else{
      for (let label of this._chartData) {
        for (let dmu of this._dmus) {        
          chartYLabels.push(label.name + " - " + dmu)          
        }
      }
    }
    
    // Axis X Labels config
    let timeUnit: 'day' | 'month' | 'year' = 'day';
    let widthValue: number;
    if (this._dateAggregation == 'daily') {
      timeUnit = 'day';
      widthValue = this.numberDaysBetweenDates(this._startDate, this._endDate);
    } else if (this._dateAggregation == 'monthly') {
      timeUnit = 'month';
      widthValue = this.numberMonthsBetweenDates(this._startDate, this._endDate);
    } else {
      timeUnit = 'year';
      widthValue = this.numberYearsBetweenDates(this._startDate, this._endDate);
    }
    // Get datasets
    let datasets: any[] = [];
    for (let label of this._chartData) {
      if(label.data.data.length>0 && !label.data.err){
        datasets.push({
          label: this.getMatrixLabelName(label.name),
          data: this.getMatrixDataFromLabel(label.name, label.data.data),
          backgroundColor: (c) => {
            const percentile = c.dataset.data[c.dataIndex].percentile;
            return label.data.colors[percentile - 1];
          },
          borderWidth: 0,
          width(c) {
            const a = c.chart.chartArea || {};
            return (a.right - a.left) / widthValue - 1;
          },
          height(c) {
            const a = c.chart.chartArea || {};
            return (a.bottom - a.top) / chartYLabels.length - 1;
          }
        })
      } else {
        this.setOpen(true);
        return;
      }     
    }

    this.minChartHeight = (this.defaultYAxisHeight * chartYLabels.length) + 60;
    // If chart is not created, then create it
    // Otherwise update chart values
    if (!this.matrixChart) {
      var ctx = document.getElementById("matrix-chart") as HTMLCanvasElement;
      this.matrixChart = new Chart(ctx, {
        type: 'matrix',
        data: {
          datasets: datasets,
        },
        options: this.getChartOptions(
          this.getMatrixScales(
            { "chartYLabels": chartYLabels },
            { "timeUnit": timeUnit }
          )
        )
      });
    } else {
      this.matrixChart.data = {
        datasets: datasets,
      };
      this.matrixChart.options = this.getChartOptions(
        this.getMatrixScales(
          { "chartYLabels": chartYLabels },
          { "timeUnit": timeUnit }
        )
      );
      this.matrixChart.update();
    }
  }

  getMatrixScales(
    chartYConfig: { chartYLabels: string[] },
    chartXConfig: { timeUnit: 'day' | 'month' | 'year' }
  ): any {
    let y = {
      type: 'category',
      offset: true,
      afterFit: (scaleInstance) => scaleInstance.width = 100,
      labels: chartYConfig.chartYLabels,
      ticks: {
        display: true
      },
      grid: {
        display: false
      },
      position: 'right',
    }

    let x = {
      type: 'time',
      position: 'bottom',
      offset: true,
      time: {
        unit: chartXConfig.timeUnit,
        displayFormat: {
          day: 'l',
          month: 'MMM YYYY',
          year: 'YYYY'
        }
      },
      grid: {
        display: false,
        drawBorder: false,
        tickLength: 10,
      }
    }
    return { "x": x, "y": y };
  }

  getMatrixDataFromLabel(labelName, dataConfiguration) {
    if(this.order==='dmu'){
      return dataConfiguration.map(
        (item) => {
          let valueData = Object.keys(item).filter((itm) => itm == labelName.toLowerCase());
          return {
            x: item.date,
            y: item.graph_unit + " - " + labelName,
            value: item[valueData[0]],
            percentile: item.percentile + 1
          }
        }
      )
    }else{
      return dataConfiguration.map(
        (item) => {
          let valueData = Object.keys(item).filter((itm) => itm == labelName.toLowerCase());
          return {
            x: item.date,
            y: labelName + " - " + item.graph_unit,
            value: item[valueData[0]],
            percentile: item.percentile + 1
          }
        }
      )
    }
    
  }

  getMatrixLabelName(labelName){
    return labelName;
  }

  // LINE CHART
  startLineChart() {

    // Axis X Labels config
    let timeUnit: 'day' | 'month' | 'year' = 'day';
    let widthValue: number;
    if (this._dateAggregation == 'daily') {
      timeUnit = 'day';
      widthValue = this.numberDaysBetweenDates(this._startDate, this._endDate);
    } else if (this._dateAggregation == 'monthly') {
      timeUnit = 'month';
      widthValue = this.numberMonthsBetweenDates(this._startDate, this._endDate);
    } else {
      timeUnit = 'year';
      widthValue = this.numberYearsBetweenDates(this._startDate, this._endDate);
    }


    // Get datasets
    let datasets: any[] = [];
    for (let label of this._chartData) {
      if(label.data.data.length>0 && !label.data.err){
        datasets.push({
          label: label.name,
          data: this.getLineDataFromLabel(label.data.data, label.name),
          borderColor: label.data.colors[4],
          tension: 0.4,
          borderWidth: 1.5
        })
      }else{
        this.setOpen(true);
        return;
      }
    }

    if (!this.lineChart) {
      var ctx = document.getElementById("line-chart") as HTMLCanvasElement;
      this.lineChart = new Chart(ctx, {
        type: 'line',
        data: {
          datasets: datasets,
        },
        options: this.getChartOptions(
          this.getLineScales({ 'timeUnit': timeUnit }), true, true
        )
      });
    } else {
      this.lineChart.data = {
        datasets: datasets,
      };
      this.lineChart.options = this.getChartOptions(
        this.getLineScales({ 'timeUnit': timeUnit }), true, true
      );
      this.lineChart.update();
    }
  }

  getLineDataFromLabel(dataConfiguration, labelName) {
    // Set datasets per well
    let datasetsPerWell = {}
    // Validate all lines per well    
    dataConfiguration.forEach(item => {
      let valueData = Object.keys(item).filter((itm) => itm == labelName.toLowerCase());
      if (!datasetsPerWell[item.graph_unit]) datasetsPerWell[item.graph_unit] = [];
      datasetsPerWell[item.graph_unit].push(
        {
          x: item.date,
          y: item.normalization,
          dmu: item.graph_unit,
          normalization: item.normalization,
          value: item[valueData[0]],
          percentile: item.percentile + 1
        }
      )
    });
    // Validate data and add it on same array
    let completeDataset: any[] = [];
    for (let well in datasetsPerWell) {
      // For separete lines you must add not a number value
      if (completeDataset.length != 0) completeDataset.push(Number.NaN);
      completeDataset = completeDataset.concat(datasetsPerWell[well]);
    }
    // Return complete dataset
    return completeDataset;
  }

  getLineScales(
    chartXConfig: { timeUnit: 'day' | 'month' | 'year' }
  ): any {
    let y = {
      display: false,
      position: 'right',
      afterFit: (scaleInstance) => scaleInstance.width = 100,
    }

    let x = {
      type: 'time',
      position: 'bottom',
      offset: true,
      time: {
        unit: chartXConfig.timeUnit,
        displayFormat: {
          day: 'l',
          month: 'MMM YYYY',
          year: 'YYYY'
        }
      },
      grid: {
        display: false,
        drawBorder: false,
        tickLength: 1,
      }
    }
    return { "x": x, "y": y };
  }



  // GENERIC METHODS

  getChartOptions(scaleOptions, showNormalized = false, showWell = false) {
    return {
      scales: scaleOptions,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          displayColors: false,
          callbacks: {
            title: (item) => {
              return item[0].raw.x;
            },
            label: (context) => {
              const v = context.dataset.data[context.dataIndex];
              let dataToShow = ['Percentil: ' + v.percentile];
              if (v.value && v.value != 'undefined') dataToShow.push('Valor: ' + v.value);
              if (showNormalized) dataToShow.push('Valor normalizado: ' + v.normalization);
              if (showWell) dataToShow.push('DMU: ' + v.dmu);
              return dataToShow;
            }
          }
        }
      }
    }
  }


  numberDaysBetweenDates(date1, date2) {
    var differenceInTime = date2.getTime() - date1.getTime();
    // To calculate the no. of days between two dates
    return differenceInTime / (1000 * 3600 * 24);
  }

  numberMonthsBetweenDates(date1, date2) {
    var months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months <= 0 ? 0 : months;
  }

  numberYearsBetweenDates(date1, date2) {
    var diff = (date2.getTime() - date1.getTime()) / 1000;
    diff /= (60 * 60 * 24);
    return Math.abs(Math.round(diff / 365.25));
  }

  setOpen(isOpen: boolean) {
    this.isToastOpen = isOpen;
  }
}
